export default {
  languages: [
    {
      name: "Dansk",
      flag: "dk",
      lang: "dk"
    },
    {
      name: "English(GB)",
      flag: "gb",
      lang: "uk"
    },
    {
      name: "English(US)",
      flag: "us",
      lang: "us"
    },
    {
      name: "Deutsch",
      flag: "de",
      lang: "de"
    },
    {
      name: "Svenska",
      flag: "se",
      lang: "se"
    },
    {
      name: "Español",
      flag: "es",
      lang: "es"
    },
    {
      name: "Français",
      flag: "fr",
      lang: "fr"
    },
    {
      name: "Русский",
      flag: "ru",
      lang: "ru"
    },
    {
      name: "Italiano",
      flag: "it",
      lang: "it"
    },
    {
      name: "Lietuvos",
      flag: "lt",
      lang: "lt"
    },
    {
      name: "Latvijas",
      flag: "lv",
      lang: "lv"
    },
    {
      name: "Eesti",
      flag: "ee",
      lang: "ee"
    },
    {
      name: "български",
      flag: "bg",
      lang: "bg"
    },
    {
      name: "Polski",
      flag: "pl",
      lang: "pl"
    }
  ]
};
